import { thoiKhoaBieuActions } from "./thoiKhoaBieuActions";
import { thoiKhoaBieuChiTietActions } from "./thoiKhoaBieuChiTietActions";

export const thoiKhoaBieuActionsWrapper = {
    thoiKhoaBieu: thoiKhoaBieuActions,
    thoiKhoaBieuChiTiet: thoiKhoaBieuChiTietActions,
}